export const selectCurrentUser = state => {
  return state.auth || {};
};

export const selectAuthorizedAuthState = state => {
  return state.auth.authorized;
};

export const selectUserType = state => {
  if (state.auth.admin) {
    return "admin";
  }
  if (state.auth.professor) {
    return "professor";
  }
  if (state.auth.nivel) {
    return "student";
  }
  return "noUser";
};

export const selectCurrentUserNivel = state => {
  if (selectUserType(state) === "student") {
    return state.auth.nivel;
  }
};

export const selectCurrentUserGroupKey = state => {
  return state.auth.groupKey;
};

export const selectCurrentUserColegio = state => {
  return state.auth.colegio;
};
